import { Reducer } from 'react';
import { Workspace } from '../components/feathers/server-interface';

export interface AuthenticationState {
  _id: string;
  username: string;
  accessToken: string;
  workspaces: Workspace[];
  defaultWorkspace:  Partial<Workspace> | undefined | string;
}

export const initialState = {
  _id: '',
  username: '',
  accessToken: '',
  workspaces: [],
  defaultWorkspace: undefined,
}

export const AuthenticationStateAction = {
  POPULATE_USER: 'populate-user' as const,
  UPDATE_USER: 'update-user' as const,
  UPDATE_USER_WS: 'update-user-ws' as const,
  LOGOUT: 'logout' as const,
  // TIMEOUT_LOGOUT: 'timeout-logout' as const,
  // FORCE_LOGOUT: 'force-logout' as const,
}

interface PopulateUserAction {
  type: typeof AuthenticationStateAction.POPULATE_USER;
  payload: {
    _id: string,
    username: string;
    accessToken: string;
    workspaces: Workspace[];
    defaultWorkspace: Partial<Workspace> | undefined | string;
  }
}

interface UpdateUserAction {
  type: typeof AuthenticationStateAction.UPDATE_USER;
  payload: {
    username: string;
    workspaces: Workspace[];
    defaultWorkspace: Partial<Workspace> | undefined | string;
  }
}

interface UpdateUserWorkspaceAction {
  type: typeof AuthenticationStateAction.UPDATE_USER_WS;
  payload: {
    defaultWorkspace: Partial<Workspace> | undefined | string;
  }
}

interface LogoutAction {
  type: typeof AuthenticationStateAction.LOGOUT;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type AuthenticationStateAction =
  | PopulateUserAction
  | UpdateUserAction
  | UpdateUserWorkspaceAction
  | LogoutAction

const reducer: Reducer<AuthenticationState, AuthenticationStateAction> = (state, action) => {
  switch (action.type) {
    case AuthenticationStateAction.POPULATE_USER:
      return {
        ...state,
        _id: action.payload._id,
        username: action.payload.username,
        workspaces: action.payload.workspaces,
        defaultWorkspace: action.payload.defaultWorkspace,
        accessToken: action.payload.accessToken,
      };
    case AuthenticationStateAction.UPDATE_USER:
      return {
        ...state,
        username: action.payload.username,
        workspaces: action.payload.workspaces,
        defaultWorkspace: action.payload.defaultWorkspace,
      };
    case AuthenticationStateAction.UPDATE_USER_WS:
      return {
        ...state,
        defaultWorkspace: action.payload.defaultWorkspace,
      };
    case AuthenticationStateAction.LOGOUT:
      sessionStorage.clear();
      return initialState;
  }
};

export default reducer;
